import { cn } from '@/lib/utils.js';

export type RepairWorkStatus = 'pending' | 'in_progress' | 'completed';

const OPTIONS: Array<{ value: RepairWorkStatus; label: string }> = [
  { value: 'pending', label: 'Pending' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'completed', label: 'Done' },
];

export function RepairStatusControl({
  value,
  disabled,
  onChange,
}: {
  value: string;
  disabled?: boolean;
  onChange: (status: RepairWorkStatus) => void;
}) {
  const current: RepairWorkStatus =
    value === 'in_progress' || value === 'completed' || value === 'pending' ? value : 'pending';

  return (
    <div
      className="grid grid-cols-3 overflow-hidden rounded-xl border border-slate-300 bg-slate-100"
      role="radiogroup"
      aria-label="Repair status"
    >
      {OPTIONS.map((opt) => {
        const selected = current === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => {
              if (!disabled && opt.value !== current) onChange(opt.value);
            }}
            className={cn(
              'min-h-[44px] px-2 text-sm font-semibold transition-colors',
              selected
                ? opt.value === 'completed'
                  ? 'bg-emerald-600 text-white'
                  : opt.value === 'in_progress'
                    ? 'bg-primary text-white'
                    : 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 active:bg-slate-200',
              disabled && 'opacity-50',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
